import { render, staticRenderFns } from "./GeneratePreview.vue?vue&type=template&id=871dc192&scoped=true&"
import script from "./GeneratePreview.vue?vue&type=script&lang=js&"
export * from "./GeneratePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871dc192",
  null
  
)

export default component.exports